var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGraphCircle32Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5A5084FF-C9B4-41C8-92E3-DAB436F76CEC_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Krediitkaart",
    transform: "translate(-753.000000, -199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(208.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(545.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Graph-Circle_32px",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 C32,24.8365565 24.8365565,32 16,32 C7.16344348,32 0,24.8365565 0,16 C0,7.16344348 7.16344348,0 16,0 C24.8365565,0 32,7.16344348 32,16 Z",
    id: "Stroke-1",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(6.000000, 10.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "0 13 6 5 12 10 20 0"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphCircle32Px);
export default __webpack_public_path__ + "static/media/Icon_Graph-Circle_32px.4a5eada4ec31962e6d3624bae37c5a17.svg";
export { ForwardRef as ReactComponent };